module.exports = __webpack_public_path__ + "static/media/img3.09794e1a.jpg";